import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { SettingsProvider } from "./context/SettingsProvider";
import { TenantProvider } from "./context/TenantContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <SettingsProvider>
        <TenantProvider>
          <App />
        </TenantProvider>
      </SettingsProvider>
    </AuthProvider>
  </BrowserRouter>
);